import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

const namespace = 'features';
export const keyPrefix = 'attach_user_departments';
export const useAttachUserDepartmentsTranslation = (): UseTranslationResponse<typeof namespace, typeof keyPrefix> => {
  return useTranslation(namespace, { keyPrefix });
};

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    title: 'Добавить',
    search_placeholder: 'Поиск',
    loading: 'Загрузка',
    empty: 'Нет доступных подразделений',
    load_error: 'Не удалось загрузить подразделения',
    on_success: 'Подразделение прикреплено',
    on_error: 'Не удалось прикрепить подразделение',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    title: 'Add',
    search_placeholder: 'Search',
    loading: 'Loading',
    empty: 'No departments available',
    load_error: 'Failed to load departments',
    on_success: 'Department attached',
    on_error: 'Failed to attach department',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    title: 'Agregar',
    search_placeholder: 'Buscar',
    loading: 'Cargando',
    empty: 'No hay departamentos disponibles',
    load_error: 'No se pudieron cargar los departamentos',
    on_success: 'Departamento adjunto',
    on_error: 'No se pudo adjuntar el departamento',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    title: 'Adicionar',
    search_placeholder: 'Pesquisar',
    loading: 'Carregando',
    empty: 'Nenhum departamento disponível',
    load_error: 'Falha ao carregar os departamentos',
    on_success: 'Departamento anexo',
    on_error: 'Não foi possível anexar o departamento',
  },
}) : {}) as Record<string, unknown>;
